import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnviosFEService {

  constructor(
    private http: HttpClient
  ) { }



  public send_sunat(id_cia: number, tipdoc: number, numint: number) {
    if (tipdoc == 1)
      return this.http.post(environment.serviceUrl_FE + "send-sunat/factura/" + id_cia + "/" + numint, null, { observe: 'response' })
    if (tipdoc == 3)
      return this.http.post(environment.serviceUrl_FE + "send-sunat/boleta/" + id_cia + "/" + numint, null, { observe: 'response' })
    if (tipdoc == 7)
      return this.http.post(environment.serviceUrl_FE + "send-sunat/nota-credito/" + id_cia + "/" + numint, null, { observe: 'response' })
    if (tipdoc == 8)
      return this.http.post(environment.serviceUrl_FE + "send-sunat/nota-debito/" + id_cia + "/" + numint, null, { observe: 'response' })
    if (tipdoc == 102)
      return this.http.post(environment.serviceUrl_FE + "send-sunat/guia-remision/" + id_cia + "/" + numint, null, { observe: 'response' })
  }

  public send_boleta(id_cia: number, numint: number) {
    return this.http.post(environment.serviceUrl_FE + "send-sunat/boleta/" + id_cia + "/" + numint, null, { observe: 'response' },)
  }

  public send_comunicacion_baja(id_cia: number, numint: number) {
    return this.http.post(environment.serviceUrl_FE + "send-sunat/comunicacion-baja/" + id_cia + "/" + numint, null, { observe: 'response' },)
  }


  public actualiza_cdr(id_cia: number, tipdoc: number, numint: number) {

    if (tipdoc == 1) {
      return this.http.post(environment.serviceUrl_FE + "send-sunat/upt-cdr/factura/" + id_cia + "/" + numint, null, { observe: 'response' })
    } else if (tipdoc == 3) {
      return this.http.post(environment.serviceUrl_FE + "send-sunat/upt-cdr/boleta/" + id_cia + "/" + numint, null, { observe: 'response' })
    } else if (tipdoc == 7) {
      return this.http.post(environment.serviceUrl_FE + "send-sunat/upt-cdr/nota-credito/" + id_cia + "/" + numint, null, { observe: 'response' })
    } else if (tipdoc == 8) {
      return this.http.post(environment.serviceUrl_FE + "send-sunat/upt-cdr/nota-debito/" + id_cia + "/" + numint, null, { observe: 'response' })
    } else if (tipdoc == 20) {
      return this.http.post(environment.serviceUrl_FE + "send-sunat/upt-cdr/retencion/" + id_cia + "/" + numint, null, { observe: 'response' })
    } else if (tipdoc == 41) {
      return this.http.post(environment.serviceUrl_FE + "send-sunat/upt-cdr/percepcion/" + id_cia + "/" + numint, null, { observe: 'response' })
    } else if (tipdoc == 102) {
      return this.http.post(environment.serviceUrl_FE + "send-sunat/upt-cdr/guia-remision/" + id_cia + "/" + numint, null, { observe: 'response' })
    } else if (tipdoc == 800) {
      return this.http.post(environment.serviceUrl_FE + "send-sunat/upt-cdr/resumen-boleta/" + id_cia + "/" + numint, null, { observe: 'response' })
    }else if (tipdoc == 801) {
      return this.http.post(environment.serviceUrl_FE + "send-sunat/upt-cdr/comunicacion-baja/" + id_cia + "/" + numint, null, { observe: 'response' })
    }


  }



}
